export enum ACTIONS {
  CHANGE_COMMISSION_MODE = 'CHANGE_COMMISSION_MODE',
  SET_COMMISSION_MODE = 'SET_COMMISSION_MODE',
}

export interface ICommissionModeState {
  isCommissionMode: boolean;
}
